import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_orderline_by_order_id_line_numberService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { order_id: number, line_number: number }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, HasChildren?: boolean, LicensePlateId?: number, LotId?: number, MaterialId?: number, PackagedAmount?: number, PackagedId?: number, SerialNumberId?: number, StatusId?: number } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.order_id)) {
      missingRequiredInParams.push('\'order_id\'');
    }
    if (isNil(inParams.line_number)) {
      missingRequiredInParams.push('\'line_number\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_orderline_by_order_id_line_number/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      order_id: number, line_number: number    }) {
        if(isNil(inParams.order_id)) {
          return true; 
        }
        if(isNil(inParams.line_number)) {
          return true; 
        }
      return false;
    }
}
